/* eslint-disable global-require */
const awsIntBase = require("../aws-int/base");

module.exports = {
  ...awsIntBase,
  domain: {
    desktop: "www.perf.use2.racing.fndlext.net",
    mobile: "www.perf.use2.racing.fndlext.net",
    talentPicks: "www.perf.use2.racing.fndlext.net/talent-picks/",
    equibase: "equibase-store.perf.use2.racing.fndlext.net"
  },
  service_host: "service.perf.use2.racing.fndlext.net",
  externalServices: {
    cpp: "https://promos-api.perf.use2.racing.fndlext.net"
  }
};
